/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({ inboxId, agentList }) {
    return axios.patch(this.url, {
      inbox_id: inboxId,
      user_ids: agentList,
    });
  }

  updateRole({ inboxId, userId, role }) {
    return axios.patch(`${this.url}/update_role`, {
      inbox_id: inboxId,
      user_id: userId,
      role,
    });
  }
}

export default new InboxMembers();
